var exports = {
  "IH": "SettingsModalHeader.module__bannerContent___blJlcU",
  "lt": "SettingsModalHeader.module__bannerTextContainer___blJlcU",
  "_M": "SettingsModalHeader.module__bannerText___blJlcU",
  "WP": "SettingsModalHeader.module__bannerTextFlash___blJlcU",
  "tD": "SettingsModalHeader.module__bannerTextNormal___blJlcU",
  "gG": "SettingsModalHeader.module__bannerActions___blJlcU",
  "ki": "SettingsModalHeader.module__titleContent___blJlcU",
  "oB": "SettingsModalHeader.module__titleWrapper___blJlcU",
  "DD": "SettingsModalHeader.module__title___blJlcU",
  "Kk": "SettingsModalHeader.module__icon___blJlcU",
  "vU": "SettingsModalHeader.module__headerTransition___blJlcU",
};

module.exports = exports;
